import { LoaderParams } from '~/components/Abstracts/Image/loader'

export const HOSTNAME = 'cdn.shopify.com'

export const imageLoaderShopify = ({ src, width }: LoaderParams) => {
  const connection = src.indexOf('?') === -1 ? '?' : '&'
  return `${src}${connection}width=${width}`
}
